var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0BB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409 -325) translate(0 63) translate(409 262)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 55c16.568 0 30 13.43 30 30 0 16.568-13.432 30-30 30-16.568 0-30-13.432-30-30 0-16.57 13.432-30 30-30zM15 30L37.501 30M15 45L55 45M15 60L45 60M15 75L40 75",
    transform: "translate(45 45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 105H2.942C1.318 105 0 103.682 0 102.057V2.943C0 1.317 1.318 0 2.941 0h50.84c.78 0 1.53.31 2.081.862L79.14 24.139c.551.552.861 1.3.861 2.08V45",
    transform: "translate(45 45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 0L55 25 79.999 25M72.672 97.518L97.988 72.201M97.988 97.518L72.671 72.201",
    transform: "translate(45 45)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 102
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportError);
export default __webpack_public_path__ + "static/media/import-error.6d2f1372.svg";
export { ForwardRef as ReactComponent };